import { Button, Drawer, DrawerBody, DrawerContent, Flex, IconButton, Text, useDisclosure } from "@chakra-ui/react"
import { tabs } from "../../../../../../common/constants/search-constants"
import { useBrandedTranslation } from "../../../../../../common/hooks/useBrandedTranslation"
import { Tab } from "../../../../../../common/types/global"
import { FhResponseData } from "../../../../../../common/types/search"
import { CClose, CPresets } from "../../../../../shared/Icons"
import ScrollShadow from "../../../../../shared/ScrollShadow"
import AllFilters from "../AllFilters"

type Props = {
  globalFilters: FhResponseData
  allSearchFilters: FhResponseData
  selectedTab: Tab
  breadcrumbFilters: FhResponseData
  currentTabCount: number
  showFiltersNoResultsView: boolean
  rid: string
}

const MobileFilters = ({
  globalFilters,
  allSearchFilters,
  selectedTab,
  breadcrumbFilters,
  currentTabCount,
  showFiltersNoResultsView,
  rid,
}: Props) => {
  const { t } = useBrandedTranslation()
  const { isOpen, onOpen, onClose } = useDisclosure()

  /* Determine the header text based on selected tab */
  const headerLabel =
    selectedTab === tabs.PRO ? t("search-filter-filter-products-by") : t("search-filter-filter-spare-parts-by")

  return (
    <>
      <Button
        rightIcon={<CPresets />}
        onClick={onOpen}
        h="11"
        pl="2"
        pr="2.5"
        w="100%"
        _active={{ bgColor: "gray.900", color: "white" }}
        aria-label="Open facet filters"
        alignItems="center"
        justifyContent="space-between"
      >
        <Text as="span" fontSize="xs" fontWeight="medium" lineHeight="4">
          {selectedTab === tabs.PRO ? t("search-filter-filter-products") : t("search-filter-filter-spare-parts")}
        </Text>
      </Button>

      <Drawer placement="right" onClose={onClose} isOpen={isOpen} size="full">
        <DrawerContent height="100dvh">
          <Flex
            as="header"
            pl={{ base: "0.5", sm: "2.5" }}
            pr={{ base: "4", sm: "6" }}
            minH="15"
            gap="2"
            fontSize="sm"
            bgColor="gray.200"
            alignItems="center"
            justifyContent="space-between"
          >
            <IconButton
              icon={<CClose />}
              bg="transparent"
              aria-label="Close facet filters"
              boxSize="12"
              onClick={onClose}
              _focusVisible={{}}
            />
            <Text textAlign="end" noOfLines={2}>
              <Text as="span">{headerLabel}</Text>
            </Text>
          </Flex>
          <DrawerBody px={{ base: "4", sm: "6" }} pt="4" pb="12" fontSize="sm">
            <Flex flexDirection="column" rowGap="2">
              <AllFilters
                globalFilters={globalFilters}
                allSearchFilters={allSearchFilters}
                breadcrumbFilters={breadcrumbFilters}
                selectedTab={selectedTab}
                showFiltersNoResultsView={showFiltersNoResultsView}
                currentTabCount={currentTabCount}
                isOverlayFilters
                closeFiltersOverlay={onClose}
                rid={rid}
              />
            </Flex>
            <ScrollShadow isVisible={true} height="20" />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default MobileFilters
